import { AppItemModel } from "../../../../projects/shared/core/app/api/models/app-item-model";

export class ApplicationItemViewModel implements AppItemModel {
  appItemKey?: string;
  appDescription?: string;
  appGroup?: string;
  appName?: string;
  orderNumber?: number;
  url?: string;
  visible?: boolean;
  accountStatusKey?: string;
  accountStatusDescription?: string;
  displayGroup?: number;
  externalAuthenticationFields?: any[];
  externalAuthenticationRequired?: boolean;
  isNewTab?: boolean;
  isActive?: boolean;


  constructor(appItemKey?: string,
    appDescription?: string,
    appGroup?: string,
    appName?: string,
    orderNumber?: number,
    url?: string,
    visible?: boolean,
    accountStatusKey?: string,
    accountStatusDescription?: string,
    isNewTab?: boolean,
    externalAuthenticationFields?: any[],
    externalAuthenticationRequired?: boolean,
    isActive?: boolean) {
    this.appItemKey = appItemKey;
    this.appDescription = appDescription;
    this.appGroup = appGroup;
    this.appName = appName;
    this.orderNumber = orderNumber;
    this.url = url;
    this.isNewTab = isNewTab;
    this.visible = visible;
    this.accountStatusKey = accountStatusKey;
    this.accountStatusDescription = accountStatusDescription;
    this.externalAuthenticationFields = externalAuthenticationFields;
    this.externalAuthenticationRequired = externalAuthenticationRequired;
    this.isActive = isActive;
  }

  get isPending() {
    return !this.isApproved && !this.isDisabled && !this.isDenied;
  };

  set isPending(value: boolean) {
    this.isPending = value;
  }

  get isApproved() {

    return (this.accountStatusKey === "401.2");
  }

  get isDenied() {
    return this.accountStatusKey === "401.3";
  }

  get isDisabled() {
    return (this.accountStatusKey) === "0" || this.accountStatusKey === "401.5";
  }

  get canShow() {
    return this.visible;
  }
}
